import React, { useState, useCallback, useEffect, useRef } from 'react'
import { getProgramListPromise } from '../../../../api/program'
import Toolbar from './toolbar'
import Table from './table'
import download from 'downloadjs'
import { useEffectOnce } from 'react-use'
import _ from 'lodash'
import { useLocation } from 'react-router-dom'

const ProgramList = props => {
  const ref = useRef()
  const location = useLocation()
  const [programs, setPrograms] = useState({})
  const [params, setParams] = useState({ page: 1 })

  // start
  useEffectOnce(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    setParams({ page: 1, ...too })
  })

  // load data
  useEffect(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())
    getProgramListPromise(too).then(resp => setPrograms(resp.data))
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const foo = Object.fromEntries(new URLSearchParams(location.search))
    const too = _.pickBy({ ...foo, page: 1, ...payload }, _.identity)
    setParams(too)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(too)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }

  function handleSearchChange (payload, delay) {
    handleParamsChange(payload, delay)
  }
  // end

  const handleExport = useCallback(() => {
    getProgramListPromise({ ...params, size: 10000, type: 'csv' })
      .then(resp => download(resp, 'programs.csv', 'application/csv'))
  }, [params])

  return (
    <div className={'root'}>
      <div className={'content'}>
        <Toolbar handleSearchChange={handleSearchChange} handleExport={handleExport} params={params} {...props} />
        <br />
        <Table
          {...props}
          data={programs}
          page={params.page}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  )
}

export default ProgramList
